// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-container {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
}

.list-container {
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
}

.result-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
}

.details-col {
  border-bottom: 20px solid white;
  display: flex;
  flex-direction: column;
  min-width: 240px;
  padding: 10px;
  position: relative;
  width: 240px;
}

.hidden {
  display: none;
}

.details-col.left {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.explanation-container {
  flex: 0 0 150px;
  width: 100%;
}

.explanation-row {
  cursor: pointer;
  font-size: 12px;
  margin: 5px 0 0 0;
  text-align: right;
  text-decoration: underline;
  width: 100%;
}

.explanation-row:hover {
  text-decoration: none;
}

.details-col.right {
  justify-content: flex-end;
}

.plot-container {
  height: 500px;
  padding: 20px 50px;
  position: relative;
  width: 900px;
}

.plot-title {
  color: #ababab;
  font-size: 16px;
  position: absolute;
  text-align: center;
  width: 60px;
}

.plot-title.top {
  top: 0;
  left: 50%;
  margin-left: -20px;
}

.plot-title.right {
  margin-top: -5px;
  top: 50%;
  right: -20px;
}

.plot-title.bottom {
  bottom: -15px;
  left: 50%;
  margin-left: -20px;
}

.plot-title.left {
  left: 0;
  margin-top: -5px;
  top: 50%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Result/Result.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,MAAM;EACN,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,QAAQ;AACV","sourcesContent":[".results-container {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.action-bar {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.list-container {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 10px;\n}\n\n.result-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.details-col {\n  border-bottom: 20px solid white;\n  display: flex;\n  flex-direction: column;\n  min-width: 240px;\n  padding: 10px;\n  position: relative;\n  width: 240px;\n}\n\n.hidden {\n  display: none;\n}\n\n.details-col.left {\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.explanation-container {\n  flex: 0 0 150px;\n  width: 100%;\n}\n\n.explanation-row {\n  cursor: pointer;\n  font-size: 12px;\n  margin: 5px 0 0 0;\n  text-align: right;\n  text-decoration: underline;\n  width: 100%;\n}\n\n.explanation-row:hover {\n  text-decoration: none;\n}\n\n.details-col.right {\n  justify-content: flex-end;\n}\n\n.plot-container {\n  height: 500px;\n  padding: 20px 50px;\n  position: relative;\n  width: 900px;\n}\n\n.plot-title {\n  color: #ababab;\n  font-size: 16px;\n  position: absolute;\n  text-align: center;\n  width: 60px;\n}\n\n.plot-title.top {\n  top: 0;\n  left: 50%;\n  margin-left: -20px;\n}\n\n.plot-title.right {\n  margin-top: -5px;\n  top: 50%;\n  right: -20px;\n}\n\n.plot-title.bottom {\n  bottom: -15px;\n  left: 50%;\n  margin-left: -20px;\n}\n\n.plot-title.left {\n  left: 0;\n  margin-top: -5px;\n  top: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
